/**
 * Amount of Faire Direct credit to give to new Faire Direct retailers
 */ export var FAIRE_DIRECT_RETAILER_AWARD_AMOUNT = 'FAIRE_DIRECT_RETAILER_AWARD_AMOUNT';
